import React, { useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { createTax, updateTax } from '../../../Utility/Api';
import { WarehouseContext } from '../../../Utility/UserContext';



const TaxesForm = ({ tax, closeModal, refreshList }) => {
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

  const [formData, setFormData] = useState({
    title: tax ? tax.title : '',
    value: tax ? tax.value : ''
  });

  const [errors, setErrors] = useState({
    title: '',
    value: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;


    if (name === "title") {
      // Only alphabets and spaces
      if (!/^[A-Za-z\s]*$/.test(value)) return;
    }
    setFormData({
      ...formData,
      [name]: value
    });

    setErrors({
      ...errors,
      [name]: ''
    });
  };

  const handleSubmit = async (e) => {
    showLoader()
    e.preventDefault();
    if (!formData.title || !formData.value) {
      toast.error('Title and value as required');
      return;
    }

    const formDataPayload = new FormData();
    formDataPayload.append('title', formData.title);
    formDataPayload.append('value', formData.value);
    formDataPayload.append('shop_id', shopItem.id);
    try {
      if (tax) {
        await updateTax(tax.id, formDataPayload);
        hideLoader()
        toast.success('Tax updated successfully');
      } else {
        await createTax(formDataPayload);
        hideLoader()
        toast.success('Tax added successfully');
      }
      closeModal();
      hideLoader()
      refreshList();
    } catch (error) {
      console.error('Error saving unit data:', error);
      hideLoader()
      toast.error(error.response?.data?.message || "Error");
    }
  };

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: 'poppins' }}>
              {tax ? 'Edit Tax' : 'Add Tax'}
            </h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>
          <div className="modal-body" style={{ fontFamily: 'poppins' }}>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.title && <small className="text-danger">{errors.title}</small>}
              </div>

              <div className="form-group mb-3">
                <label>Value</label>
                <input
                  type="number"
                  name="value"
                  value={formData.value}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.value && <small className="text-danger">{errors.value}</small>}
              </div>

              <button type="submit" className="btn btn-success float-end">
                {tax ? 'Update Tax' : 'Add Tax'}
              </button>
              <button
                type="button"
                className="btn btn-secondary float-end me-1"
                onClick={closeModal}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxesForm;
